<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pbottom-10">
        <DataFilter
                :prime="!$root.isEmbeddedMode ? {title: 'Projects.add'} : undefined"
                :search="{}"
                :right="filtersCtrls"
                :filters="filters"
                v-on:prime="createProject"
                v-on:change="handleInput"
        />
      </div>
      <div style="clear: both;"></div>
      <card body-class="no-padding table-responsive">
        <pagedlist
                :offset="filters.offset"
                :limit="filters.limit"
                :count="filters.count"
                :pages="filters.pages"
                v-on:refresh="refresh"
        >
          <DataTable :columns="columns" :data="table.body" v-on:refresh="refresh" >
            <template v-slot:default="{row, col}">
              <template v-if="col.id === 'status'">
                <template v-if="row.transaction">
                  <a v-on:click="openOrder(row.transaction)">
                    <project-status-badge :status="row.status"/>
                  </a>
                </template>
                <div v-else>
                  <project-status-badge :status="row.status"/>
                </div>
              </template>
              <template v-else-if="col.id === 'transactionstatus'">
                <order-status-badge
                  :order="Object.assign({}, row, {status: row.transaction ? row.transactionstatus : row.status})"
                />
              </template>
              <template v-else-if="col.id === 'creationdate' || col.id === 'lastmodified' || col.id === 'orderdate' || col.id === 'orderduedate'">{{ row[col.id] | formatDate }}</template>
              <template v-else-if="col.id === 'name'">
                <a v-on:click="$parent.openProject(row.ID)">{{ row.name }}</a>
              </template>
              <template v-else-if="col.id === 'transaction'">
                <a v-on:click="$parent.openOrder(row.transaction)">{{ row.transactionnum }}</a>
              </template>
              <template v-else-if="col.id === 'mixed'">
                <a v-on:click="row.transaction ? $parent.openOrder(row.transaction, 'Projects') : $parent.openProject(row.ID)">{{ row.name }}</a>
              </template>
              <div v-else-if="col.id === 'workflow'">
                <workflow-badge :workflow="row.workflow"/>
              </div>
              <template v-else>{{ row[col.id] }}</template>
            </template>
          </DataTable>
        </pagedlist>
      </card>
    </div>
  </div>
</template>
<script>
import DataTable from '../Elements/DataTable.vue';
import DataFilter from '../Elements/DataFilter.vue';
import ProjectStatusBadge from '../Elements/ProjectStatusBadge';
import OrderStatusBadge from '../Elements/OrderStatusBadge';
import WorkflowBadge from '../Elements/WorkflowBadge';

var columnsDefinition = {
  id: {
    id: 'ID',
    sortable: true,
    label: 'Projects.projectNumber'
  },
  name: {
    id: 'name',
    sortkey: 'name',
    sortable: true,
    label: 'Projects.projectName'
  },
  mixed: {
    id: 'mixed',
    sortable: true,
    label: 'Projects.projectName'
  },
  creationdate: {
    id: 'creationdate',
    sortable: true,
    label: 'Common.creationdate'
  },
  lastmodified: {
    id: 'lastmodified',
    sortable: true,
    label: 'Common.lastmodified'
  },
  status: {
    id: 'status',
    sortable: true,
    label: 'Common.status'
  },
  transaction: {
    id: 'transaction',
    sortkey: 'transactionnum',
    sortable: true,
    label: 'Orders.orderNum'
  },
  transactionnum: {
    id: 'transactionnum',
    sortable: true,
    label: 'Orders.orderNum'
  },
  transactionstatus: {
    id: 'transactionstatus',
    sortable: true,
    label: 'Common.status'
  },
  workflow: {
    id: 'workflow',
    sortable: false,
    label: 'Projects.projectType'
  }
}

var view = require('../view.js'),
    viewData = {
      filters: {
        offset: 0,
        limit: 20,
        count: 0,
        pages: 0,
        status: '',
        search: '',
        orderby: 'id',
        tag: '',
        workflow: null,
      },
      columns: [],
      table: {
        body: []
      },
      status: [
        {label: 'Projects.statusAll', value: ''},
        {label: 'Projects.statusOpen', value: 0},
        {label: 'Projects.statusOrdered', value: 1}
      ],
      workflows: []
    };

export default view(viewData, {
  components: {
    DataTable,
    DataFilter,
    ProjectStatusBadge,
    OrderStatusBadge,
    WorkflowBadge,
  },
  mounted() {
    this.$parent.viewTitle = this.$t('Projects.title');

    this.filters = Object.assign({}, this.filters, this.parseFilters());

    this.columns = [];
    let columns = typeof this.$root.projectColumns === 'object' ? this.$root.projectColumns : [
      'id',
      'name',
      'creationdate',
      'lastmodified',
      'status',
    ];
    columns.forEach((col) => {
      this.columns.push(columnsDefinition[col]);
    });

    this.workflows = Object.entries(this.$root.workflowTypes || {})
            .filter(([_, def]) => def.visibility !== false && def.locked !== true)
            .map(([type, def]) => {
              return {
                value: type,
                label: this.$t(def.title),
              }
            });

    this.refresh(0);
  },
  computed: {
    orderStatusCodes() {
      return typeof this.$root.orderStatusCodes == 'object' ? this.$root.orderStatusCodes : {};
    },
    orderColumn() {
      if (this.filters.orderby.startsWith('-')) {
        return this.filters.orderby.substring(1)
      }
      return this.filters.orderby;
    },
    isStatusPickerAvailable() {
      if (this.$parent.viewIndex == null) {
        return true
      }
      return isNaN(parseInt(this.$parent.viewIndex, 10)) && this.$parent.viewIndex && this.$parent.viewIndex.indexOf('status:') < 0;
    },
    isWorkflowPickerAvailable() {
      return true;
    },
    filtersCtrls() {
      let x = [];
      if (this.isWorkflowPickerAvailable) {
        x.push({
          id: 'workflow',
          options: this.workflows,
          placeholder: 'Projects.projectType'
        })
      }

      if (this.isStatusPickerAvailable) {
        x.push({
          id: 'status',
          options: this.status,
          placeholder: 'Common.status'
        })
      }

      return x;
    },
  },
  methods: {
    async refresh(offset, orderby) {
      this.$forceUpdate()

      if (orderby) {
        this.filters.orderby = orderby
      }

      const params = Object.assign({}, this.filters);

      if (offset != null)
        params.offset = offset;

      Object.entries(params)
        .filter( ([, param]) => param == null || param === '')
        .forEach(([key]) => {
          delete params[key];
        })

      try {
        delete params.count;
        delete params.pages;
        const {data} = await this.$http.get(this.$root.url + 'project/', {params});
        this.table.body = data.result.data;
        this.filters.count = data.result.count;
        this.filters.offset = data.result.offset;
        this.filters.limit = data.result.limit;
        this.filters.pages = data.result.pages;
      } catch (res) {
        this.table.body = [];
        console.log('Fail', res);
      }
    },
    parseFilters() {
      const filter = this.$parent.viewIndex || '';
      if (filter == null) {
        return {};
      }

      const status = parseInt(filter, 10);
      if (!isNaN(status)) {
        return {
          status,
          tag: '',
        }
      }

      return Object.assign({
        status: '',
        tag: '',
      }, ...filter.split(',')
        .map(filter => filter.split(':'))
        .filter(x => x.length === 2)
        .map(([key, value]) => ({
          [key]: isNaN(parseInt(value, 10)) || (parseInt(value, 10) != value) ? value : parseInt(value, 10)
        }))
      );
    },
    handleInput() {
      console.log('filters updated');
      this.$forceUpdate()
      this.refresh(0);
    },
    handleSearch() {
      // this.$refs.txtSearch.focus();
      this.handleInput();
    },
    resetSearch() {
       viewData.filters.search = '';
       this.handleInput();
    },
    createProject() {
      this.$parent.$refs.newProject.openDialog();
    },
    openOrder(ID) {
      this.$parent.openView('OrderDetails', ID);
    },
    onHeaderClick(col) {
      if (col.sortable) {
        var sortkey = typeof col.sortkey === 'string' ? col.sortkey : col.id;

        if (sortkey === this.orderColumn) {
          viewData.filters.orderby = (viewData.filters.orderby.startsWith('-') ?  '' : '-') + this.orderColumn;
        } else {
          viewData.filters.orderby = '-' + sortkey;
        }
        this.refresh(0);
      }
    }
  }
});
</script>

<style scoped>
  th.sortable {
    cursor: pointer;
  }
</style>
